import { motion } from 'framer-motion'
import { steps, stats } from '../data.ts'
import SectionHeading from './SectionHeading.tsx'
import React from 'react'

export default function Process() {
  return (
    <section id="process" className="relative py-24 sm:py-32">
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute left-1/2 top-1/3 h-80 w-80 -translate-x-1/2 rounded-full bg-brand-700/20 blur-[120px]" />
      </div>

      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        <SectionHeading
          eyebrow="How we work"
          title={<>A simple, proven <span className="text-gradient">4-step process</span></>}
          subtitle="No jargon, no surprises. You'll always know where your project stands."
        />

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-4">
          {steps.map((s, i) => (
            <motion.div
              key={s.title}
              initial={{ opacity: 0, y: 28 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-60px' }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="relative rounded-2xl border border-white/10 bg-white/[0.03] p-6"
            >
              {/* <span className="absolute -top-3 left-6 grid h-7 w-7 place-items-center rounded-full bg-brand-500 text-xs font-bold text-ink-950">
                {i + 1}
              </span> */}
              <span className="mt-2 grid h-11 w-11 place-items-center rounded-xl bg-brand-500/15 text-brand-300">
                <s.icon size={20} />
              </span>
              <h3 className="mt-4 font-display text-lg font-semibold text-white">{s.title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-slate-400">{s.desc}</p>
            </motion.div>
          ))}
        </div>

        {/* Stats band */}
        <motion.div
          initial={{ opacity: 0, y: 24 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '-60px' }}
          transition={{ duration: 0.6 }}
          className="mt-16 grid grid-cols-2 gap-4 rounded-3xl border border-white/10 bg-gradient-to-r from-brand-900/30 to-ink-900/40 p-8 sm:p-10 lg:grid-cols-4"
        >
          {stats.map((s) => (
            <div key={s.label} className="text-center lg:text-left">
              <div className="font-display text-3xl font-extrabold text-gradient sm:text-4xl">{s.value}</div>
              <div className="mt-1 text-sm text-slate-400">{s.label}</div>
            </div>
          ))}
        </motion.div>
      </div>
    </section>
  )
}
